import React from 'react';

export function DevPage() {
    return <></>;
}

DevPage.route = '/dev';
